<div class="top-bar" [class.company-secondary]="secondaryCompany">
  <app-company-selector class="company-selector"></app-company-selector>
  <!-- <button
    type="button"
    class="btn-vantix"
    title="Abrir EROLY "
    [disabled]="cargandoVantix"
    (click)="irEROLY ()"
  >
    <span class="brand__mark"></span>

    <span>
      {{ cargandoVantix ? "Conectando..." : "EROLY " }}
    </span>
  </button> -->

    <!-- CARNET DIGITAL -->
  <button
    type="button"
    class="digital-card-trigger"
    title="Mi carnet digital"
    aria-label="Abrir mi carnet digital"
    (click)="openDigitalCard($event)"
  >
    <mat-icon>qr_code_2</mat-icon>
  </button>

  <button
    class="btn-directory"
    (click)="openDirectoryModal()"
    title="Contactos"
  >
    <mat-icon>contacts</mat-icon>
  </button>

  <a
    title="Soporte"
    class="btn-support"
    href="https://wa.me/593986343538?text=Hola%20equipo%20SOPORTE%20IT%20NOVAX%2C%20requiero%20ayuda%20con%20un%20tema.%20%C2%BFMe%20apoyan%3F"
    target="_blank"
    rel="noopener noreferrer"
  >
    <img src="assets/social/whatsapp.svg" alt="WhatsApp" class="support-icon" />
    <span>Soporte</span>
  </a>

  <button class="btn-lms" (click)="irLMS()" title="Capacitaciones">
    <mat-icon>school</mat-icon><span>Capacitaciones</span>
  </button>

  <div *ngIf="canViewMeetingsCenter" class="meetings-center">
    <button
      type="button"
      class="meetings-trigger"
      [class.is-open]="meetingsOpen"
      (click)="toggleMeetings($event)"
      title="Mi agenda"
      aria-label="Abrir mis próximos eventos y reuniones"
      [attr.aria-expanded]="meetingsOpen"
    >
      <mat-icon>event_available</mat-icon>
      <span
        *ngIf="upcomingMeetingsTotal > 0"
        class="meetings-trigger__badge"
      >
        {{ upcomingMeetingsTotal > 9 ? '9+' : upcomingMeetingsTotal }}
      </span>
    </button>

    <section
      *ngIf="meetingsOpen"
      class="meetings-popover"
      (click)="$event.stopPropagation()"
      aria-label="Próximos eventos y reuniones"
    >
      <header class="meetings-popover__header">
        <div>
          <span>AGENDA PERSONAL</span>
          <h3>Próximos eventos y reuniones</h3>
          <p>Agenda sincronizada con Microsoft y ZIVO.</p>
        </div>
        <button
          type="button"
          class="meetings-popover__refresh"
          [disabled]="meetingsLoading"
          (click)="syncMicrosoftAndLoadUpcoming(true)"
          title="Actualizar reuniones"
          aria-label="Actualizar reuniones"
        >
          <mat-icon [class.is-spinning]="meetingsLoading">refresh</mat-icon>
        </button>
      </header>

      <div class="meetings-popover__actions">
        <button type="button" class="meeting-quick-action meeting-quick-action--primary" (click)="createMeeting($event)">
          <mat-icon>add</mat-icon>
          Nuevo evento / reunión
        </button>
        <button type="button" class="meeting-quick-action" (click)="viewAllMeetings($event)">
          <mat-icon>calendar_month</mat-icon>
          Ver agenda completa
        </button>
      </div>

      <div class="meetings-popover__body">
        <div *ngIf="meetingsLoading" class="meetings-popover__state">
          <span class="meetings-popover__spinner"></span>
          <strong>Consultando agenda</strong>
          <small>Cargando las reuniones más cercanas…</small>
        </div>

        <div *ngIf="!meetingsLoading && meetingsError" class="meetings-popover__state meetings-popover__state--error">
          <mat-icon>error_outline</mat-icon>
          <strong>No se pudo cargar la agenda</strong>
          <small>{{ meetingsError }}</small>
          <button type="button" (click)="syncMicrosoftAndLoadUpcoming(true)">Reintentar</button>
        </div>

        <div
          *ngIf="!meetingsLoading && !meetingsError && upcomingMeetings.length === 0"
          class="meetings-popover__state"
        >
          <mat-icon>event_busy</mat-icon>
          <strong>No tienes eventos próximos</strong>
          <small>Programa un evento o reunión desde este panel.</small>
        </div>

        <button
          *ngFor="let meeting of upcomingMeetings"
          type="button"
          class="meeting-preview"
          [attr.data-provider]="meeting.provider"
          (click)="manageMeeting(meeting, $event)"
        >
          <span class="meeting-preview__date" [class.is-today]="isMeetingToday(meeting)">
            <b>{{ meeting.start_at | date: 'dd' }}</b>
            <small>{{ meeting.start_at | date: 'MMM' }}</small>
          </span>
          <span class="meeting-preview__content">
            <strong>{{ meeting.subject }}</strong>
            <small>
              {{ meeting.start_at | date: 'HH:mm' }}–{{ meeting.end_at | date: 'HH:mm' }}
              <ng-container *ngIf="meeting.location"> · {{ meeting.location }}</ng-container>
            </small>
            <span class="meeting-preview__provider">
              <mat-icon>{{ meetingProviderIcon(meeting) }}</mat-icon>
              {{ meetingProviderLabel(meeting) }}
            </span>
          </span>
          <mat-icon class="meeting-preview__arrow">chevron_right</mat-icon>
        </button>
      </div>

      <footer class="meetings-popover__footer">
        <span>Se muestran hasta 6 elementos próximos de tu agenda.</span>
        <button type="button" (click)="viewAllMeetings($event)">Ver todas</button>
      </footer>
    </section>
  </div>

  <!-- NOTIFICACIONES -->
  <div class="notificaciones-wrapper">
    <button
      title="Notificaciones"
      class="notificaciones-container"
      type="button"
      (click)="toggleNotificaciones($event)"
    >
      <span class="badge" *ngIf="notificacionesNoLeidas > 0">
        {{ notificacionesNoLeidas }}
      </span>

      <mat-icon>notifications</mat-icon>
    </button>

    <div
      class="bandeja"
      *ngIf="mostrarNotificaciones"
      (click)="$event.stopPropagation()"
    >
      <div class="bandeja-inner">
        <div class="titulo">Notificaciones</div>

        <div class="filtros">
          <button
            class="filtro"
            [class.activo]="filtro === 'todas'"
            (click)="cambiarFiltro('todas')"
          >
            Todas
          </button>

          <button
            class="filtro"
            [class.activo]="filtro === 'no_leidas'"
            (click)="cambiarFiltro('no_leidas')"
          >
            Sin leer
          </button>

          <button
            class="filtro"
            *ngIf="notificacionesNoLeidas > 0"
            (click)="marcarTodas()"
          >
            Marcar todas como leídas
          </button>
        </div>

        <div class="lista-scroll">
          <div
            class="notificacion"
            *ngFor="let n of notificaciones"
            [class.no-leida]="!n.is_read"
            (click)="abrirNotificacion(n)"
          >
            <p>{{ n.notification?.message }}</p>
            <small>{{ n.created_at | timeAgo }}</small>
          </div>

          <div *ngIf="notificaciones.length === 0" class="vacio">
            No tienes notificaciones
          </div>
        </div>

        <div class="footer">
          <a
            href="/notifications/notif"
            target="_blank"
            rel="noopener noreferrer"
            class="ver-todas-btn"
          >
            Ver todas
          </a>
        </div>
      </div>
    </div>
  </div>
  <div
    title="Cuenta"
    class="usuario-info"
    (click)="toggleMenu()"
    [class.abierto]="menuAbierto"
  >
    <span>
      <span *ngIf="perfilCompleto === 'true'" class="advertencia">⚠️</span>
      {{ nombreUsuario }} {{ apellidosUsuario }}
    </span>

    <img [src]="imagenPerfil" alt="Foto de perfil" class="foto-perfil" />

    <div class="submenu" *ngIf="menuAbierto">
      <a routerLink="/perfil">
        Perfil
        <span *ngIf="perfilCompleto === 'true'" class="advertencia">⚠️</span>
      </a>
      <a routerLink="/credenciales">Credenciales</a>
      <a *ngIf="employeeExternalId" (click)="irMisAsistencias()">
        Mis asistencias
      </a>

      <section
        *ngIf="employeeExternalId"
        class="lodging-account-section"
        (click)="$event.stopPropagation()"
        aria-label="Mi hospedaje"
      >
        <div class="lodging-account-section__head">
          <span>MI HOSPEDAJE · HOY</span>
          <button
            type="button"
            class="lodging-account-refresh"
            title="Actualizar mi hospedaje"
            aria-label="Actualizar mi hospedaje"
            [disabled]="myLodgingLoading"
            (click)="loadMyLodging($event)"
          >
            <mat-icon [class.is-spinning]="myLodgingLoading">refresh</mat-icon>
          </button>
        </div>

        <div
          *ngIf="myLodgingLoading && !myLodgingData"
          class="lodging-account-state"
        >
          Consultando asignación…
        </div>

        <div
          *ngIf="!myLodgingLoading && myLodgingError"
          class="lodging-account-state lodging-account-state--error"
        >
          {{ myLodgingError }}
        </div>

        <ng-container *ngIf="myLodgingData">
          <div class="lodging-account-work">
            <span
              [class.is-work]="myLodgingData.work_state === 'WORK'"
              [class.is-rest]="myLodgingData.work_state === 'REST'"
            >
              {{ myLodgingWorkLabel() }}
            </span>
            <small>{{ myLodgingData.date | date: 'dd/MM/yyyy':'UTC' }}</small>
          </div>

          <strong class="lodging-account-place">
            {{ myLodgingPlace() }}
          </strong>

          <small
            *ngIf="myLodgingData.assignment?.location"
            class="lodging-account-pickup"
          >
            Lugar: {{ myLodgingData.assignment.location }}
          </small>

          <small
            *ngIf="myLodgingData.assignment?.pickup"
            class="lodging-account-pickup"
          >
            Referencia: {{ myLodgingData.assignment.pickup }}
          </small>

          <a
            *ngIf="myLodgingData.assignment?.google_maps_url"
            class="lodging-account-maps"
            [href]="myLodgingData.assignment.google_maps_url"
            target="_blank"
            rel="noopener noreferrer"
            (click)="$event.stopPropagation()"
          >
            Abrir ubicación en Google Maps
          </a>

          <small
            *ngIf="!myLodgingData.employee?.identification_valid"
            class="lodging-account-warning"
          >
            Tu cédula no está registrada. Comunícate con RRHH.
          </small>
        </ng-container>
      </section>

      <a routerLink="/configuracion">Configuración</a>

      <section
        class="avatar-account-section"
        (click)="$event.stopPropagation()"
        aria-label="Asistente ZIVO"
      >
        <span class="avatar-account-title">
          ASISTENTE ZIVO · {{ avatarVisible ? 'VISIBLE' : 'OCULTO' }}
        </span>

        <button
          type="button"
          class="avatar-account-action"
          [attr.aria-pressed]="avatarVisible"
          (click)="toggleAvatar($event)"
        >
          <mat-icon>{{ avatarVisible ? 'visibility_off' : 'smart_toy' }}</mat-icon>
          {{ avatarVisible ? 'Ocultar asistente' : 'Mostrar asistente' }}
        </button>

        <button
          type="button"
          class="avatar-account-action"
          (click)="openAvatarSettings($event)"
        >
          <mat-icon>tune</mat-icon>
          Personalizar
        </button>
      </section>

      <button class="logout-btn" (click)="cerrarSesion()">Cerrar sesión</button>
    </div>
  </div>
</div>

<app-meeting-modal-shared
  [show]="meetingModalOpen"
  [mode]="meetingModalMode"
  [meetingExternalId]="meetingModalExternalId"
  [initialData]="meetingModalInitialData"
  title="Programar reunión"
  contextLabel="Agenda personal de ZIVO"
  [allowCancel]="true"
  [allowComplete]="false"
  (saved)="onMeetingModalSaved($event)"
  (closed)="onMeetingModalClosed($event)"
></app-meeting-modal-shared>

<div class="ui-toast-container">
  <div
    class="ui-toast"
    [class.fade-out]="n.closing"
    *ngFor="let n of uiNotifications"
    (click)="n.link && abrirDesdeToast(n)"
  >
    <button
      class="ui-toast-close"
      (click)="cerrarToast(n, $event)"
      aria-label="Cerrar notificación"
    >
      ✕
    </button>

    <div class="ui-toast-title">Notificación</div>
    <div class="ui-toast-message">{{ n.message }}</div>
    <div class="ui-toast-time">
      {{ n.createdAt | date: "HH:mm:ss" }}
    </div>
  </div>
</div>

<div class="directory-overlay" *ngIf="directoryOpen" (click)="closeDirectory()">
  <div class="directory-modal" (click)="$event.stopPropagation()">
    <div class="directory-header">
      <h3>Directorio de usuarios</h3>
      <input [formControl]="directorySearch"
        placeholder="Buscar nombre, apellido, cédula, cargo, correo o teléfono..."
        aria-label="Buscar usuarios" />
      <div class="directory-options">
        <label>
          <input type="checkbox" [checked]="directoryIncludeInactive"
            (change)="onDirectoryIncludeInactiveChange($event)" />
          Incluir usuarios inactivos
        </label>
        <small *ngIf="!loadingDirectory">{{ directoryTotal }} resultados</small>
      </div>
    </div>
    <div class="directory-body">
      <div *ngIf="loadingDirectory" class="empty">Buscando usuarios...</div>
      <div *ngIf="directoryError" class="empty">
        {{ directoryError }}
        <button type="button" class="directory-retry" (click)="loadDirectoryUsers(directoryPage)">Reintentar</button>
      </div>
      <div class="directory-user" *ngFor="let u of directoryUsers">
        <div class="user-info">
          <div class="directory-copy-line">
            <span [innerHTML]="highlight(u.nombreCompleto)"></span>
            <button type="button" class="directory-copy-button" title="Copiar nombres"
              [attr.aria-label]="'Copiar nombres de ' + u.nombreCompleto"
              (click)="copyDirectoryValue(u.nombreCompleto, 'Nombre')">
              <mat-icon>content_copy</mat-icon>
            </button>
            <small *ngIf="u.activo === false" class="directory-inactive">Inactivo</small>
          </div>
          <div class="contact-block directory-copy-line">
            <small class="main-email">Correo: {{ directoryEmail(u) || 'Sin registrar' }}</small>
            <button *ngIf="directoryEmail(u)" type="button" class="directory-copy-button"
              title="Copiar correo" aria-label="Copiar correo"
              (click)="copyDirectoryValue(directoryEmail(u), 'Correo')">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
          <div class="contact-block directory-copy-line" *ngIf="directoryPhone(u) as phone">
            <span class="phone">Celular: {{ phone }}</span>
            <button type="button" class="directory-copy-button"
              title="Copiar celular" aria-label="Copiar celular"
              (click)="copyDirectoryValue(phone, 'Celular')">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
          <div class="user-meta">
            <div class="roles-container">
              <span class="role-chip" *ngFor="let r of (u.cargos || '').split(',')"
                [hidden]="!r.trim()">{{ r.trim() }}</span>
            </div>
            <div class="contact-block">
              <div class="contactos-extra" *ngIf="u.contactos?.length">
                <div class="contacto-item" *ngFor="let c of u.contactos">
                  <span class="contacto-icon">
                    <mat-icon *ngIf="c.type === 'email'">mail</mat-icon>
                    <mat-icon *ngIf="c.type === 'phone'">phone</mat-icon>
                    <mat-icon *ngIf="c.type === 'whatsapp'">chat</mat-icon>
                  </span>
                  <span class="contacto-valor">{{ c.value }}</span>
                  <span class="contacto-label" *ngIf="c.label">({{ c.label }})</span>
                  <button type="button" class="directory-copy-button" title="Copiar contacto"
                    (click)="copyDirectoryValue(c.value, 'Contacto')"><mat-icon>content_copy</mat-icon></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!loadingDirectory && !directoryError && !directoryUsers.length"
        class="empty">No se encontraron usuarios</div>
    </div>
    <div class="directory-footer">
      <div class="directory-pagination">
        <button type="button" [disabled]="loadingDirectory || directoryPage <= 1"
          (click)="loadDirectoryUsers(directoryPage - 1)">Anterior</button>
        <small>Página {{ directoryPage }} de {{ directoryTotalPages || 1 }}</small>
        <button type="button" [disabled]="loadingDirectory || directoryPage >= directoryTotalPages"
          (click)="loadDirectoryUsers(directoryPage + 1)">Siguiente</button>
      </div>
      <button class="btn btn--ghost" (click)="closeDirectory()">Cerrar</button>
      <small *ngIf="directoryCopyMessage" class="directory-copy-feedback" role="status">
        {{ directoryCopyMessage }}
      </small>
    </div>
  </div>
</div>

<div
  *ngIf="digitalCardOpen"
  class="digital-card-overlay"
  role="dialog"
  aria-modal="true"
  aria-label="Mi carnet digital"
  (click)="closeDigitalCard($event)"
>
  <section
    class="digital-card-modal"
    (click)="$event.stopPropagation()"
  >
    <header class="digital-card-modal__header">
      <div>
        <span>IDENTIDAD ZIVO</span>
        <h2>Mi carnet digital</h2>
      </div>

      <button
        type="button"
        class="digital-card-close"
        title="Cerrar"
        aria-label="Cerrar carnet"
        (click)="closeDigitalCard($event)"
      >
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <div
      *ngIf="digitalCardLoading"
      class="digital-card-state"
    >
      <span class="digital-card-spinner"></span>

      <strong>Preparando carnet…</strong>

      <small>
        Generando su identificación digital segura.
      </small>
    </div>

    <div
      *ngIf="
        !digitalCardLoading &&
        digitalCardError &&
        !digitalCardData
      "
      class="digital-card-state digital-card-state--error"
    >
      <mat-icon>error_outline</mat-icon>

      <strong>No se pudo cargar el carnet</strong>

      <small>
        {{ digitalCardError }}
      </small>

      <button
        type="button"
        (click)="retryDigitalCard($event)"
      >
        Reintentar
      </button>
    </div>

    <ng-container
      *ngIf="!digitalCardLoading && digitalCardData"
    >
      <div
        #digitalCard
        class="digital-card"
      >
        <div class="digital-card__brand">
          <div class="digital-card__brand-mark">
            Z
          </div>

          <div>
            <strong>ZIVO ERP</strong>
            <span>CARNET DIGITAL</span>
          </div>
        </div>

        <div class="digital-card__identity">

          <div class="digital-card__photo-wrap">
            <img
              [src]="
                imagenPerfil ||
                '../../../../assets/img/default_user.png'
              "
              alt="Foto de carnet"
              class="digital-card__photo"
            />
          </div>

          <span class="digital-card__eyebrow">
            COLABORADOR
          </span>

          <h3>
            {{ digitalCardData.full_name }}
          </h3>

          <small
            *ngIf="digitalCardData.employee_external_id"
          >
            Identidad corporativa verificada
          </small>

          <small
            *ngIf="!digitalCardData.employee_external_id"
          >
            Identidad de usuario ZIVO
          </small>
        </div>

        <div class="digital-card__divider"></div>

        <div class="digital-card__qr-block">
          <span>
            QR ÚNICO DE IDENTIFICACIÓN
          </span>

          <img
            [src]="digitalCardData.qr_data_url"
            alt="Código QR único del carnet digital"
            class="digital-card__qr"
          />

          <small>
            {{ digitalCardData.identity_hint }}
          </small>
        </div>

        <footer class="digital-card__footer">
          <span>ZIVO · Identidad digital</span>

          <span>
            v{{ digitalCardData.version }}
          </span>
        </footer>
      </div>

      <p class="digital-card-note">
        Este QR identifica su cuenta de forma única.
        No contiene cédula, nombres ni credenciales
        dentro del código.
      </p>

      <div
        *ngIf="digitalCardError"
        class="digital-card-inline-error"
      >
        <mat-icon>error_outline</mat-icon>

        <span>{{ digitalCardError }}</span>
      </div>

      <div class="digital-card-actions">
        <button
          type="button"
          class="digital-card-secondary"
          (click)="closeDigitalCard($event)"
        >
          Cerrar
        </button>

        <button
          type="button"
          class="digital-card-download"
          [disabled]="digitalCardDownloading"
          (click)="downloadDigitalCard()"
        >
          <mat-icon>
            {{
              digitalCardDownloading
                ? 'hourglass_top'
                : 'download'
            }}
          </mat-icon>

          {{
            digitalCardDownloading
              ? 'Generando…'
              : 'Descargar carnet'
          }}
        </button>
      </div>

    </ng-container>
  </section>
</div>
